/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import _ from 'lodash'
import { Popup, Table, Divider, Label } from 'semantic-ui-react'
import styled from 'styled-components'
import utils from '../../../utils'

const Container = styled.div`
  margin: 3px 0px;
  font-weight: bold;
`
const HighlightDiv = styled.div`
  font-size: 15;
  margin-bottom: 6;
  color: gray;
  cursor: pointer;
`
const STATUS_COLORS = { delivered: 'green', rejected: 'red', pending: 'yellow' }
export default class SenderCell extends React.Component {
  state = { senderPhoneVisibility: false, receiverPhoneVisibility: false }

  render() {
    const { senderPhoneVisibility, receiverPhoneVisibility } = this.state
    const { id, requestor, receivers } = this.props
    let { senderName, senderPhone } = this.props
    const multipleReceiverInfo = receivers.length > 1 ? `(${receivers.length})` : ''

    const firstReceiver = receivers[0] || {}
    const { receiver_name: receiverName = 'Unknown', receiver_phone: receiverPhone = '---' } = firstReceiver

    senderName = senderName || 'Unknown'
    senderPhone = senderPhone || '---'
    return (
      <Table.Cell>
        <Container>
          <Popup
            trigger={
              <div style={{ fontSize: 14, cursor: 'pointer' }}>
                Order Number: {utils.order.getExpressOrderNumber(senderPhone, id)}
              </div>
            }
            on="click"
            hideOnScroll
          >
            ID: {id}
          </Popup>

          <Divider />
          <Popup
            trigger={<HighlightDiv>Sender:</HighlightDiv>}
            on="click"
            hideOnScroll
          >
            Requestor:
            {requestor && (
              <div>
                Name: {requestor.name} <br />
                Phone: {requestor.phone}
              </div>
            )}
          </Popup>

          <div style={{ fontSize: 14 }}>{senderName}</div>
          <div
            style={{ color: 'grey', fontSize: 13, cursor: 'pointer' }}
            onClick={() => this.setState({ senderPhoneVisibility: !senderPhoneVisibility })}
          >
            {senderPhoneVisibility
              ? senderPhone
              : senderPhone.substring(0, 6) + (senderPhone.length === 12 ? 'xxxxxx' : 'xxxxxxx')}
          </div>
          <Divider />
          <Popup
            trigger={<HighlightDiv>Receiver {multipleReceiverInfo}:</HighlightDiv>}
            class="hide-scrollbar"
            on="click"
            hideOnScroll
            flowing
            position="right center"
            style={{overflowY: 'auto', maxHeight: 400}}
          >
            <ReceiverPopupContent receivers={receivers} />
          </Popup>

          <div style={{ fontSize: 14 }}>{receiverName}</div>
          <div
            style={{ color: 'grey', fontSize: 13, cursor: 'pointer' }}
            onClick={() => this.setState({ receiverPhoneVisibility: !receiverPhoneVisibility })}
          >
            {receiverPhoneVisibility
              ? receiverPhone
              : receiverPhone.substring(0, 6) + (receiverPhone.length === 12 ? 'xxxxxx' : 'xxxxxxx')}
          </div>
        </Container>
      </Table.Cell>
    )
  }
}

const ReceiverPopupContent = ({ receivers }) => {
  return (
    <React.Fragment>
      <p style={{ fontWeight: 'bold', fontSize: 15 }}>Drop Offs:</p>
      {receivers.map(receiver => {
        const {
          receiver_name: receiverName = 'Unknown',
          receiver_phone: receiverPhone = '---',
          distance,
          status,
          key,
        } = receiver
        const displayDistance = distance ? `${parseFloat(distance / 1000).toFixed(2)} km` : '---'
        return (
          <div key={key}>
            <Divider />
            <div>
              Name: {receiverName} <br />
              Phone: {receiverPhone}
              <br />
              Distance: {displayDistance}
              <br />
              Status:{' '}
              <Label size="tiny" color={STATUS_COLORS[status]}>
                {_.capitalize(status)}
              </Label>
            </div>
          </div>
        )
      })}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/containers/express/components/SenderCell.js